import { InjectionToken, Provider, Signal } from '@angular/core';

/** Context for schema-driven components and data sources – provided by the host application. */
export type DataSourceContext = Record<string, unknown>;

/**
 * Where `$context.X` and `$$context.X$$` read from. One bag for every node in reach — there is no
 * per-node slice of it, which is why it is a token rather than something a node declares.
 *
 * A data source and an action are built in the environment injector, which holds none of the element
 * providers, so the renderer hands each of them the context its node reads. A host may therefore publish
 * it on a route and on a component alike, and a node and its source never read two different ones.
 */
export const SCHEMA_CONTEXT = new InjectionToken<Signal<DataSourceContext>>('SCHEMA_CONTEXT');

/**
 * Publishes the ambient values a schema may name. The renderer fills none of them, the way no registry
 * ships built-ins: a host provides one wherever it renders schemas, and a node that names a key no host
 * publishes simply resolves to nothing.
 */
export function provideSchemaContext(context: () => Signal<DataSourceContext>): Provider {
  return { provide: SCHEMA_CONTEXT, useFactory: context };
}
